module.exports = __webpack_public_path__ + "img/UTOTTE-6.51f23238.jpg";